import Cookies from 'js-cookie';

export const removeNonRequiredCookies = (cookieLists) => {
  const { domain } = document;
  const parts = domain.split('.');
  const sndLevelDomain = parts.slice(-2).join('.');

  ['functional', 'tracking', 'thirdPartySurvey'].forEach((key) =>
    cookieLists.cookieList[key]?.forEach((item) => {
      // Some cookies are register to the domain, others to sub domain.
      // But we cannot know before which cookies are on what domain.
      // So for each cookie name we remove it from both.
      [domain, sndLevelDomain].forEach((subKey) =>
        Cookies.remove(item.name, { path: '/', domain: subKey }),
      );
    }),
  );
};

export const acceptRequiredCookies = (cookieLists) => {
  const newCookieServiceNameList = cookieLists.cookieServiceNameList;

  newCookieServiceNameList.functional.forEach(
    (item) => (item.accepted = false),
  );
  newCookieServiceNameList.tracking.forEach((item) => (item.accepted = false));
  newCookieServiceNameList.thirdPartySurvey?.forEach(
    (item) => (item.accepted = false),
  );
  Cookies.set(
    'cookie_consent_list_fo',
    JSON.stringify(newCookieServiceNameList),
    {
      expires: 120,
    },
  );
};
